export default __webpack_public_path__ + "static/media/THUGS-NAR.6efeb418.png";